import api from 'api/apiClient';
import { ensureFileId } from 'modules/shared/service';
import { formatDate } from 'modules/shared/utils';
import { API_LEAVE_STATUS_KEYS } from '../constants';
import { calculateLeaveDuration } from '../utils';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export async function getMyLeaves(id) {
  if (!id) throw new Error('Employee ID is needed to fetch all leaves data');

  const { data: raw } = await unwrap(await api.get(`/api/leave-requests/${id}`));

  const normalized = {
    pending: [],
    approved: [],
    rejected: [],
  };

  raw.forEach((leave) => {
    const uiStatus = API_LEAVE_STATUS_KEYS[leave.status];
    if (!uiStatus) return;

    normalized[uiStatus].push({
      id: leave.id,
      employeeId: leave.employee_id,
      employeeName: leave.employee_name,
      department: leave.department,
      leaveType: leave.leave_type,
      startDate: formatDate(leave.start_date),
      endDate: leave.end_date ? formatDate(leave.end_date) : null,
      startSession: leave.start_date_session,
      endSession: leave.end_date_session ?? null,
      numberOfDays: Number(leave.number_of_days),
      isPaid: Boolean(leave.is_paid),
      appliedOn: formatDate(leave.applied_on),
      reason: leave.reason,
      status: uiStatus,
      rejectionReason: leave.rejection_reason ?? null,
    });
  });

  return normalized;
}

export async function applyForLeave(id, data) {
  if (!id || !data)
    throw new Error('Employee id and application form data is required to apply for leave');

  const duration = calculateLeaveDuration({
    startDate: data.startDate,
    startSession: data.startSession,
    endDate: data.endDate,
    endSession: data.endSession,
  });

  const payload = {
    employee_id: id,
    leave_type: data.leaveType,
    start_date: formatDate(data.startDate, 'YYYY-MM-DD'),
    end_date: data.endDate ? formatDate(data.endDate, 'YYYY-MM-DD') : null,
    start_date_session: data.startSession,
    end_date_session: data.endSession ? data.endSession : null,
    number_of_days: duration,
    reason: data.reason,
    attachment: await ensureFileId(data.attachment),
    applied_on: new Date().toISOString(),
  };

  await unwrap(await api.post('/api/leave-request', payload));
}
